// extracted by mini-css-extract-plugin
module.exports = {"ChipIcon":"Chip_ChipIcon__hAE5v","Chip":"Chip_Chip__1EWRX","clickable":"Chip_clickable__3k382"};